<section class="lp-countries-hero-jumbotron">
  <div class="row">
    <div class="col-12">
      <h2 class="shop-and-ship-page-section-title">Service Options Tailored for {{activeCountry.country_nat}} Shoppers</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="shop-and-ship-service-opitons-wrapper">
        <div class="service-opitons-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/package-forwarding.png"
            alt=""
          />
          <strong>Package Forwarding</strong>
          <p>
            Already comfortable shopping internationally? Simply use your Shippn address at checkout, and we'll forward your purchases to <span *ngIf="activeCountry?.country_name === 'United States of America' || activeCountry?.country_name === 'United Kingdom'"> the </span>{{activeCountry?.country_name}}.
          </p>
        </div>

        <div class="service-opitons-shippn">
          <img
            src="assets/img/lp-countries/why-choose-shippn/buy-for-me-shopping-bags.png"
            alt=""
          />
          <strong>Buy For Me Service</strong>
          <p>
            Can't complete a purchase yourself?
            <br>Our team will buy the items for you using our secure payment system
            <br>perfect for:
          </p>
          <ul>
            <li>Websites that reject {{activeCountry.country_nat}} credit cards</li>
            <li>Stores requiring local phone verification</li>
            <li>Retailers with region-restricted items</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
